/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import {
  FETCHING_CONSENT_DOCUMENTS_FOR_SOP,
  FETCHED_CONSENT_DOCUMENTS_FOR_SOP,
  FETCH_CONSENT_DOCUMENTS_FOR_SOP_ERROR,
  CLEAR_CONSENT_DOCUMENTS_FOR_SOP,
  FETCHED_CONSENTING_OPTIN_STATE_FOR_SOP
} from '../actions/actionTypes';

const initialDocumentStatusChangeSoPState = {
  isFetching: false,
  consentDocumentData: null,
  consentingOptInState: null,
  error: null
};

const documentStatusSoP = (state = initialDocumentStatusChangeSoPState, action) => {
  switch (action.type) {
    case FETCHING_CONSENT_DOCUMENTS_FOR_SOP:
      return Object.assign({}, state, { isFetching: true, error: null });
    case FETCHED_CONSENT_DOCUMENTS_FOR_SOP:
      return Object.assign({}, state, { isFetching: false, consentDocumentData: action.payload, error: null });
    case FETCH_CONSENT_DOCUMENTS_FOR_SOP_ERROR:
      return Object.assign({}, state, { isFetching: false, error: action.payload });

    case FETCHED_CONSENTING_OPTIN_STATE_FOR_SOP:
      return Object.assign({}, state, { isFetching: false, consentingOptInState: action.payload, error: null });

    case CLEAR_CONSENT_DOCUMENTS_FOR_SOP:
      return Object.assign({}, {}, initialDocumentStatusChangeSoPState);

    default:
      return state;
  }
};

export default documentStatusSoP;
